import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as actions from "../../Actions/transactions";
import { CLEARED_CODING } from "../../Actions/common";
import { acceptRuleMatchedTransaction } from "../../Actions/transactionHelpers";
import { connect } from "react-redux";
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import SplitTransaction from '../Transaction/SplitTransaction';
import MatchTransaction from '../Transaction/MatchTransaction';
import UnmatchTransaction from '../Transaction/UnmatchTransaction';
import TransactionStats from '../TransactionsMenu/TransactionStats';
import TransactionRule from '../Rules/RuleModal';
import TransactionComment from '../Comments/CommentModal';
import TransactionListMenu from './TransactionListMenu';
import RemoveTransactionTable from './RemoveTransactionTable';
import ReactGA from 'react-ga';
import { TRACKING_CODE } from "../../Actions/types";
import TransactionDataTable from './TransactionDataTable'
import TransactionContextMenu from './TransactionContextMenu/transactionContextMenu';
import { connectMenu } from "react-contextmenu";
import SendTransactions from '../SendTransactions/SendTransactions';

ReactGA.initialize(TRACKING_CODE);

class TransactionListPage extends Component {
  state = {
    showModal: false,
    showSendModal: false,
    showRule: false,
    transaction: {},
    setActive: false,
    removeSelected: [],
    transactionStats: {},
    loadModal: '',
    unallocated: 0,
    rahSync: false,
    codeOpen: false,
    sendOpen: false,
    focusedCell: {},
    rowsVersion: Math.random(),
  };

  componentDidMount() {
    const { bookId, account, dateRange, getTransactions } = this.props;
    this.enableRules = localStorage.getItem("enablerules");
    
    getTransactions(bookId, account, dateRange);
        if (localStorage.getItem('filterBy')) {
            this.props.updateFilterBy(localStorage.getItem('filterBy'));
        }
  }

  componentWillUnmount() {
    if (this.props.isRah) window.clearInterval(this.rahSync);
    if (this.state.codingDetails) {
      this.props.codeTransaction(
        this.state.codingDetails,
        this.props.dateRange,
        this.props.timeStamp,
        this.props.noSync,
        this.props.account
      );
      this.setState({ codingDetails: undefined });
    }
  }

  isRuleFound = (row) =>
    ((this.props.isRah || this.enableRules) &&
    row &&
    row.Coding[0] &&
    row.Coding[0].CodingType === 'Rule') ||
    (this.props.isR1 && row && row.matchedRule && !row.Coding[0] && !row.locked);

  prepareAndCodeTransaction = (codingDetails) => {
    codingDetails.Coding.map((item) => {
      if (!item.accountCodeId && item.CodingType !== 'Rule')
        item.accountCodeId =
          codingDetails.accountCodeId || '00000000-0000-0000-0000-000000000000';
      if (!item.AccountDate)
        item.AccountDate = moment.utc(item.CodedDate).unix();
      return item;
    });
    this.props.codeTransaction(
      codingDetails,
      this.props.dateRange,
      this.props.timeStamp,
      this.props.noSync,
      this.props.account
    );
  };

  uncodeTransaction = (row) => {
    this.handleSelectAccount({}, row, true);
  };

  leaveRow = (newCoordination) => {
    // If cursor has moved up / down a row then focus on account select control and save last change
    setTimeout(() => {
      if (this.state.codingDetails) {
        this.prepareAndCodeTransaction(this.state.codingDetails);
        this.setState({ codingDetails: undefined });
      }
    }, 10);
  };

  removeCheckboxClicked = (value) => {
    if (this.state.removeSelected.includes(value)) {
      this.setState({
        removeSelected: this.state.removeSelected.filter(
          (item) => item !== value
        ),
      });
    } else {
      const removeSelected = this.state.removeSelected.slice();
      removeSelected.push(value);
      this.setState({ removeSelected });
    }
  };

  selectAllCheckboxClicked = (rows) => {
    const selectedItems = this.state.removeSelected.slice();
    if (selectedItems.length !== rows.length) {
      this.setState({
        removeSelected: rows.map((row) => row.BankDataGUID),
      });
    } else {
      this.setState({ removeSelected: [] });
    }
  };

  closeModal = () => {
    ReactGA.event({ category: 'User', action: 'Openned add rule modal' });
    this.setState({ showModal: false, showRule: false, setActive: true });
  };

  cancelSplit = () => {
    this.setState({ showModal: false, showRule: false, setActive: true });
    // this[`${this.state.transaction.BankDataGUID}_acc`].select.clearValue();
  };

  toggleRule = () => {
    this.setState({ showRule: !this.state.showRule });
  };

  setUnallocated = (value) => {
    this.setState({ unallocated: value });
  };

  closeRemoveModal = () => {
    this.props.closeRemoveModal();
    this.setState({ removeSelected: [] });
  };

  removeSelectedTransactions = () => {
    this.props.removeSelectedTransactions(
      this.state.removeSelected,
      this.closeRemoveModal,
      this.props.dateRange,
      this.props.account
    );
  };

  handleRefreshRows = () => {
    this.setState({ rowsVersion: Math.random() });
  };

  matchTransaction = (bookId, transaction, updatedMatches) => {
    const isRah = (localStorage.getItem("authtype") === 'RAH');

    // Find the selected match for this transaction
    const match = updatedMatches && updatedMatches.find(
      m => m.MatchId === transaction.MatchId
    );

    // If no corresponding match is found, do nothing
    if (!match) {
      return;
    }

    const payload = { ...match, clientAccountId: transaction.ClientAccountID };

    if (isRah) {
      // Route RAH users to the appropriate action
      if (this.props.matchRAHTransaction) {
        this.props.matchRAHTransaction(bookId, transaction, payload);
      }
    } else {
      if (this.props.matchR1Transaction) {
        this.props.matchR1Transaction(bookId, transaction, payload);
      }
    }

    // Keep local matches state and UI in sync
    if (this.props.updateMatches) {
      this.props.updateMatches(updatedMatches);
    }
    this.handleRefreshRows();
  };

  handleAcceptRule = async (transaction) => {    
    if (transaction.matchedRule) {
      // Use GraphQL mutation for matched rules
      try {
        const result = await acceptRuleMatchedTransaction(
          this.props.bookId,
          this.props.account.bankId,
          transaction
        );
        
        if (result.allocationResults && result.allocationResults[0] && result.allocationResults[0].isSuccess) {
          // Mark transaction as coded by rule for UI purposes
          this.props.codedByR1Rule(transaction);

          // Move cell focus to next row
          this.setState({ moveCell: { x: 1, y: 0, version: Math.random() } });

        } else {
          const msg = (result.allocationResults && result.allocationResults[0] && result.allocationResults[0].errorMessage) || 'Rule allocation failed';
          this.props.showError(msg);
        }

      } catch (error) {
        this.props.showError('Rule allocation failed');
      }
    } else {
      // Non-GraphQL rule flow for existing RAH/R1 transactions without matchedRule
      if (transaction.Coding && transaction.Coding[0]) {
        transaction.Coding[0].CodingType = 'Rule';
      }
      this.props.ruleTransaction(transaction);
      // Move cell focus to next row
      this.setState({ moveCell: { x: 1, y: 0, version: Math.random() } });
    }
  };

  handleToggleLockTransaction = (transaction) => {
    this.props.deselectTransaction(transaction);
    this.props.toggleTransactionLock(
      {
        ...transaction,
        isTransactionLocked: !transaction.isTransactionLocked,
      },
      this.props.bookId
    );
  };

  handleSelectAccount = (value, row, shouldCode) => {
    const {
      bankAccounts,
      bookId,
      hasGST,
      transactionsList,
      transactionCodes: { taxCodes },
      matches,
      removeMatchButton,
      stopMatchLoading,
    } = this.props;
    let updatedMatches = [...matches];
    const transaction = {
      ...transactionsList.find(
        (item) => item.BankDataGUID === row.BankDataGUID
      ),
    };
    if (value) {
      if (value.value === 'split' || value.value === 'match') {
        if (value.value === 'split') {
          window.clearInterval(this.timer);
          ReactGA.event({ category: 'User', action: 'Openned split screen' });
        }
        transaction.Coding = transaction.Coding.map((item) => {
          if (typeof item.Amount === 'number')
            item.Amount = item.Amount.toFixed(2); // Format cents for coded transaction from api
          return item;
        });
        this.setState({
          showModal: true,
          loadModal: value.value,
          transaction,
        });
      } else {
        transaction.Coding = [];
        transaction.AccountCode = value.value;
        ReactGA.event({ category: 'User', action: 'Coded a transaction' });
        removeMatchButton(transaction.BankDataGUID);
        stopMatchLoading(transaction.BankDataGUID);

        // transaction matching
        if (value.isMatch) {
          if (transaction.MatchId !== value.value) {
            updatedMatches = matches.map((match) => {
              if (match.TransactionId === row.BankDataGUID)
                match.TransactionId = null;
              return match;
            });
          }
          updatedMatches = updatedMatches.map((match) => {
            if (match.MatchId === value.value)
              match.TransactionId = row.BankDataGUID;
            return match;
          });
          transaction.MatchId = value.value;
        } else {
          updatedMatches = updatedMatches.map((match) => {
            if (match.TransactionId === row.BankDataGUID)
              match.TransactionId = null;
            return match;
          });
          transaction.MatchId = null;
        }
        // update transaction and match
        if (transaction.MatchId !== row.MatchId) {
          this.matchTransaction(bookId, transaction, updatedMatches);
        }

        // if (!value.value) this[`${row.BankDataGUID}_acc`].select.blur();

        // Check is select account type is a bank account (transfer) or a charted account
        if (value.accountType !== 9) {
          transaction.accountCodeId = value.accountId || '';
        } else {
          // Account is a bank account
          transaction.accountCodeId = bankAccounts.find(
            (item) => item.accountId === value.accountId
          ).bankId;
        }

        transaction.accountType = value.accountType || ''; // set accountType or empty string if deleting transtaction coding

        // Book is registered for GST and the account code has a default GST code then add GST to transaction
        if (hasGST) {
          let taxCode = undefined;
          transaction.GstCode = '';
          if (value.defaultTaxCode) {
            taxCode = taxCodes.find(
              (code) => code.value === value.defaultTaxCode
            );
            transaction.GstCode = value.defaultTaxCode;
          }
          transaction.gstCodeId = taxCode ? taxCode.taxAccountId : '';
          transaction.gstAmount = taxCode
            ? transaction.Amount - transaction.Amount / (1 + taxCode.rate / 100)
            : 0;
        } else {
          transaction.GstCode = undefined;
          transaction.gstAmount = undefined;
        }
        this.codeSelectAccount(transaction, row, shouldCode);
      }
    } else {
      // show modal when deleting a match
      if (transaction.MatchId) {
        return this.setState({
          showModal: true,
          loadModal: 'unmatch',
          transaction,
        });
      } else {
        Object.assign(transaction, CLEARED_CODING);
      }
      this.codeSelectAccount(transaction, row, shouldCode);
    }
  };

  focusedCellChange = (focusedCellDetails) => {
    this.setState({ focusedCell: focusedCellDetails });
  };

  activateCell = () => {
    this.props.handleSelectCell({
      x: this.state.focusedCell.x,
      y: this.state.focusedCell.y,
      key: this.state.focusedCell.key,
      active: true,
    });
  };

  codeSelectAccount = (transaction, row, shouldCode) => {
    const codingDetails = this.prepareCodingDetails(transaction, row);
    transaction.Coding = codingDetails.Coding;
    this.setcodingDetails(codingDetails, shouldCode);
    this.props.updateTransactionsList(transaction);
  };

  handleGST = (gstValue, row) => {
    const {
      transactionsList,
      transactionCodes: { taxCodes },
    } = this.props;
    const transaction = {
      ...transactionsList.find(
        (item) => item.BankDataGUID === row.BankDataGUID
      ),
    };
    transaction['GST'] = gstValue;
    transaction['GstCode'] = gstValue ? gstValue.value : gstValue;
    transaction['gstCodeId'] = gstValue ? gstValue.taxAccountId : gstValue;
    transaction['gstAmount'] =
      gstValue && gstValue.taxAccountId
        ? transaction.Amount -
          transaction.Amount /
            (1 +
              taxCodes.find((code) => code.value === gstValue.value).rate / 100)
        : 0;
    if (!gstValue) transaction.Coding = [];
    this.updateAndCodeTransaction(transaction, row, false);
  };

  handleContact = (contactValue, row) => {
    const {
      transactionsList,
      transactionCodes: { taxCodes },
    } = this.props;
    const transaction = {
      ...transactionsList.find(
        (item) => item.BankDataGUID === row.BankDataGUID
      ),
    };
    transaction['Contact'] = contactValue;
    transaction['contactId'] = contactValue ? contactValue.value : contactValue;
    if (contactValue && contactValue.DefaultTaxCode) {
      if (!row.Coding.GstCode) {
        const taxCode = taxCodes.find(
          (taxCode) => taxCode.TaxAccountListID === contactValue.DefaultTaxCode
        );
        if (taxCode) {
          transaction['GstCode'] = taxCode.value;
          transaction.gstCodeId = taxCode.taxAccountId;
          transaction.gstAmount = taxCode.taxAccountId
            ? transaction.Amount -
              transaction.Amount /
                (1 +
                  taxCodes.find((code) => code.value === taxCode.value).rate /
                    100)
            : 0;
        }
      }
    }
    this.updateAndCodeTransaction(transaction, row, false);
  };

  handleClassification = (contactValue, row) => {
    const transaction = {
      ...this.props.transactionsList.find(
        (item) => item.BankDataGUID === row.BankDataGUID
      ),
    };
    transaction['Classification'] = contactValue;
    transaction['classificationId'] = contactValue
      ? contactValue.value
      : contactValue;
    this.updateAndCodeTransaction(transaction, row, false);
  };

  handleDescription = (descriptionValue, row) => {
    const transaction = {
      ...this.props.transactionsList.find(
        (item) => item.BankDataGUID === row.BankDataGUID
      ),
    };
    if (transaction && descriptionValue !== transaction.Description) {
      if (!transaction['OriginalDescription'])
        transaction['OriginalDescription'] = transaction['Description'];
      transaction['Description'] = descriptionValue;
      if (transaction['OriginalDescription'] !== transaction['Description'])
        transaction['isDescriptionUpdated'] = true;
      this.updateAndCodeTransaction(transaction, row, false);
    }
  };

  handleUndoDescription = (row) => {
    const transaction = {
      ...this.props.transactionsList.find(
        (item) => item.BankDataGUID === row.BankDataGUID
      ),
    };
    transaction['Description'] = transaction['OriginalDescription'];
    transaction['isDescriptionUpdated'] = false;
    this.updateAndCodeTransaction(transaction, row, true);
  };

  handleQuantity = (qtyValue, row) => {
    const transaction = {
      ...this.props.transactionsList.find(
        (item) => item.BankDataGUID === row.BankDataGUID
      ),
    };
    if ((row.Quantity || '').toString() !== qtyValue) {
      transaction['Quantity'] = qtyValue;
      this.updateAndCodeTransaction(transaction, row, false);
    }
  };

  setcodingDetails = (codingDetails, shouldCode) => {
    if (shouldCode) this.prepareAndCodeTransaction(codingDetails);
    else this.setState({ codingDetails });
  };

  prepareCodingDetails = (transaction, row) => {
    const { account, bookId, isR1, isRah } = this.props;
    const codingDetails = {
      BookId: bookId,
      bankId: transaction.bankId ? transaction.bankId : account.bankId,
      BankDataGuid: row.BankDataGUID,
      Coding:
        !transaction.MatchId && transaction.AccountCode
          ? this.prepareCodingObject(transaction, row.Coding)
          : [],
      clientAccountId: account.value,
      description: transaction.Description,
      accountCodeId: transaction.accountCodeId || ''
    };
    //accountCode
    if (
      !transaction.MatchId &&
      transaction.AccountCode &&
      transaction.AccountCode !== 'split'
    ) {
      codingDetails.Coding[0].AccountCode = transaction.AccountCode;
    }
    // contactId
    if (transaction.contactId) codingDetails.contactId = transaction.contactId;
    // classificationId
    if (transaction.classificationId) {
      codingDetails.classificationId = transaction.classificationId;
    } else if (this.props.classification.length) {
      const defaultCallId = this.props.classification.find(
        (item) => item.isDefault
      );
      codingDetails.classificationId = defaultCallId
        ? defaultCallId.value
        : undefined;
    }
    // Quantity
    if (codingDetails.Coding[0])
      codingDetails.Coding[0].Quantity = transaction.Quantity
        ? parseInt(transaction.Quantity, 10)
        : undefined;
    // GST
    if (transaction.GstCode && (transaction.GstCode !== "0" || (!isR1 && !isRah))) {
      codingDetails.Coding[0].GstCode = transaction.GstCode;
      codingDetails.Coding[0].gstCodeId =
        transaction.gstCodeId ||
        this.props.transactionCodes.taxCodes.find(
          (code) => code.value === transaction.GstCode
        ).taxAccountId;
      codingDetails.Coding[0].gstAmount = transaction.gstAmount;
    }
    return codingDetails;
  };

  prepareCodingObject = (transaction, currentCoding) => {
    const { transactionCodes: { taxCodes }, isR1, isRah } = this.props;
    // Check if transacton is already coded if it is set R1 accountCodeId and gstCodeId
    if (transaction.Coding && transaction.Coding[0]) {
      if (!transaction.accountCodeId && transaction.Coding.length < 2)
        transaction.accountCodeId = transaction.Coding[0].R1AccountId;
      if (!transaction.gstCodeId)
        transaction.gstCodeId = transaction.Coding[0].R1TaxGroupId;

      // If transaction is split, add AccountDate
      if (transaction.Coding.length > 1) {
        const AccountDate = moment
          .utc(transaction.TransactionDate, 'D MMM YY')
          .unix();
        transaction.Coding.forEach((item) => (item.AccountDate = AccountDate));
      }
      if (transaction.Coding[0].Quantity === null)
        transaction.Coding[0].Quantity = undefined;
    } else {
      const coding = {
        Percentage: 100,
        Amount: transaction.Amount,
        CodingType: 'QuickCoding',
      };
      coding.AccountDate = moment
        .utc(transaction.TransactionDate, 'D MMM YY')
        .unix();
      coding.AccountCode = transaction.AccountCode
        ? transaction.AccountCode
        : '';
      coding.AccountType = transaction.accountType;
      coding.accountCodeId = transaction.accountCodeId;

      if (transaction.Quantity) coding.Quantity = parseInt(transaction.Quantity, 10);
      if (transaction.GstCode && (transaction.GstCode !== "0" || (!isR1 && !isRah))) {
        coding.GstCode = transaction.GstCode;
        coding.gstCodeId =
          transaction.gstCodeId ||
          taxCodes.find((code) => code.value === coding.GstCode).taxAccountId;
        coding.gstAmount = transaction.gstAmount;
      }
      return [coding];
    }
    return currentCoding;
  };

  showSplitModalHandler = (row) => {
    this.setState({ showModal: true, loadModal: 'split', transaction: row });
  };

  showSendToClientModalHandler = (row) => {
    this.setState({ showModal: true, loadModal: 'send' });
  };

  showRuleModalHandler = (row) => {
    this.setState({
      showModal: true,
      loadModal: 'Rule',
      transaction: row,
      codingDetails: undefined,
    });
  };

  showCommentModalHandler = (row) => {
    this.setState({
      showModal: true,
      loadModal: 'Comment',
      transaction: row,
    });
  };

  saveSplitTransaction = (values) => {
    const {
      bankAccounts,
      account,
      bookId,
      timeStamp,
      transactionsList,
      transactionCodes: { taxCodes },
    } = this.props;
    const AccountDate = moment
      .utc(this.state.transaction.TransactionDate, 'D MMM YY')
      .unix();
    const Coding = _.map(values.Coding, (item) => {
      item.Amount = parseFloat(item.Amount);
      item.gstAmount = parseFloat(item.gstAmount);
      if (this.state.transaction.Amount < 0) {
        item.Amount = item.Amount * -1;
        item.gstAmount = item.gstAmount * -1;
      }
      _.omit(item, ['moneyOut']);
      const codedItem = {
        ...item,
        projectId:
          !item.R1ProjectId || typeof item.R1ProjectId === 'string'
            ? item.R1ProjectId
            : item.R1ProjectId.value,
        AccountCode:
          typeof item.AccountCode === 'string'
            ? item.AccountCode
            : item.AccountCode.value,
        accountCodeId:
          typeof item.AccountCode === 'string'
            ? this.props.transactionCodes.chart.find(
                (chartItem) => chartItem.value === item.AccountCode
              ).accountId
            : item.AccountCode.accountId,
        AccountDate,
        AccountType: item.AccountCode.accountType,
        CodingType: 'QuickCoding',
      };
      codedItem.Quantity = item.Quantity ? item.Quantity : undefined;
      if (item.GstCode) {
        const gstCode =
          typeof item.GstCode === 'string' ? item.GstCode : item.GstCode.value;
        const taxCode = taxCodes.find((code) => code.value === gstCode);
        codedItem.GstCode = gstCode;
        codedItem.gstCodeId = taxCode ? taxCode.taxAccountId : undefined;
      }
      if (item.Description) codedItem.Description = item.Description;
      return codedItem;
    });

    const codingDetails = {
      BookId: bookId,
      bankId: account.bankId,
      BankDataGuid: this.state.transaction.BankDataGUID,
      Coding,
      clientAccountId: account.value,
      contactId:
        typeof values.contactId === 'string'
          ? values.contactId
          : values.contactId
          ? values.contactId.value
          : undefined,
      classificationId:
        typeof values.classificationId === 'string'
          ? values.classificationId
          : values.classificationId
          ? values.classificationId.value
          : undefined,
    };

    if (
      values.Coding.length === 1 &&
      values.Coding[0].AccountCode.accountType === 9
    ) {
      codingDetails.accountCodeId = bankAccounts.find(
        (item) => item.accountId === values.Coding[0].AccountCode.accountId
      ).bankId;
      codingDetails.Coding[0].accountCodeId = codingDetails.accountCodeId;
    }

    const rowIndex = transactionsList.findIndex(
      (item) => item.BankDataGUID === this.state.transaction.BankDataGUID
    );
    const updatedList = [...transactionsList];
    updatedList[rowIndex].Coding = Coding;
    updatedList[rowIndex].AccountCode = 'split';
    if (values.contactId && typeof values.contactId !== 'string')
      updatedList[rowIndex].contactId = values.contactId.value;
    this.props.codeTransaction(codingDetails, this.props.dateRange, timeStamp, this.props.noSync, this.props.account);
    this.closeModal();

    if (
      values.ruleName &&
      (values.transactionAmount || values.transactionDescription)
    ) {
      const rule = {
        Description: values.ruleName,
        Definition: [],
        PaymentReceipt: { Description: '', Allocations: [] },
      };

      rule.Definition.push({
        Field: 'MoneyInOut',
        Operator: values.typeOperator || '1',
        Value: '',
      });

      if (values.amountOperator && values.transactionAmount) {
        rule.Definition.push({
          Field: 'Amount',
          Operator: values.amountOperator,
          Value: values.transactionAmount.toString(),
        });
      }

      if (values.descriptionOperator && values.transactionDescription) {
        rule.Definition.push({
          Field: 'Description',
          Operator: values.descriptionOperator,
          Value: values.transactionDescription.toString(),
        });
      }

      rule.PaymentReceipt.Allocations = values.Coding.map((item) => ({
        AccountCode:
          item.AccountCode && typeof item.AccountCode !== 'string'
            ? item.AccountCode.value
            : item.AccountCode,
        Percentage: Math.round(item.Percentage * 1),
        TaxCode:
          item.GstCode && typeof item.GstCode !== 'string'
            ? item.GstCode.value || ''
            : item.GstCode || '',
        Description: item.Description || '',
      }));
      this.props.postRule(rule, bookId);
    }
  };

  setMoveCell = (moveCell) => {
    this.setState(moveCell);
  };

  copyCoding = (currentTransaction, sourceCoding) => {
    const {
      transactionCodes: { taxCodes },
      isRah,
    } = this.props;
    if (sourceCoding.Coding.length === 1) {
      const chartItem = this.props.transactionCodes.chart.find(
        (item) => item.value === sourceCoding.AccountCode
      );
      if (
        chartItem &&
        (Math.sign(sourceCoding.Amount) ===
          Math.sign(currentTransaction.Amount) &&
          (!isRah || sourceCoding.Coding[0].CodingType !== 'Rule'))
      ) {
        const transaction = { ...currentTransaction };
        transaction.AccountCode = sourceCoding.AccountCode;
        transaction.accountCodeId =
          sourceCoding.Coding[0].accountCodeId ||
          sourceCoding.Coding[0].R1AccountId ||
          '00000000-0000-0000-0000-000000000000';
        transaction.GstCode = sourceCoding.GstCode;
        transaction.contactId = sourceCoding.contactId;
        transaction.classificationId = sourceCoding.classificationId;
        transaction.Coding = [];
        if (transaction.GstCode) {
          const taxCode = taxCodes.find(
            (code) => code.value === transaction.GstCode
          );
          transaction.gstAmount =
            transaction.Amount - transaction.Amount / (1 + taxCode.rate / 100);
          transaction.gstCodeId = taxCode.taxAccountId;
        }

        this.updateAndCodeTransaction(transaction, currentTransaction, false);
        this.setState({ moveCell: { x: 1, y: 0, version: Math.random() } });
      }
    }
  };

  toggleCodeOpen = () => {
    this.setState((prevState) => ({ codeOpen: !prevState.codeOpen }));
  };

  toggleSendOpen = (selectedTransactions) => {
    this.setState((prevState) => ({ sendOpen: !prevState.sendOpen }));
    this.setState({
      showModal: true,
      loadModal: 'send',
      selectedTransactionsToSend: selectedTransactions,
    });
  };

  deselectTransaction = (transaction) => {
    this.setState({ codeOpen: false });
    this.props.deselectTransaction(transaction);
  };

  deselectTransactions = () => {
    return this.selectTransactions([]);
  };

  selectTransaction = (transaction) => {
    this.setState({ codeOpen: false });
    this.props.selectTransaction(transaction);
  };

  selectTransactions = (transactions) => {
    this.setState({ codeOpen: false });
    return this.props.selectTransactions(transactions);
  };

  logMessage = (value) => {
    console.log(value);
  };

  updateAndCodeTransaction(transaction, row, shouldCode) {
    const codingDetails = this.prepareCodingDetails(transaction, row);
    transaction.Coding = codingDetails.Coding;
    this.setcodingDetails(codingDetails, shouldCode);
    this.props.updateTransactionsList(transaction);
  }

  updateTransactionsStat = (transactionStats) => {
    this.setState({ transactionStats });
  };

  render() {
    const {
      transactionCodes,
      apiError,
      projects,
      classification,
      contacts,
      hasGST,
      taxTracking,
      isSaving,
      isR1,
      isRah,
      showRemoveModal,
      postToRAH,
      bookId,
      account,
      dateRange,
      timeStamp,
      editableDescription,
      matches,
      retryQueueRAH,
      queueState,
      filename,
      version,
      sortOrder,
      sortColumn,
      displayAccount,
      transactionsList,
      matchLoadingList,
      hideColumns,
      getTransactions,
      removeMatchButton,
      codingErrors,
      isLoadingTransactions,
      hasFeeds
    } = this.props;

    if (!hasFeeds) {
      return null;
    }

    const enableRules = localStorage.getItem("enablerules");

    const flip = this.state.transaction.Amount < 0 ? -1 : 1;
    let displayModal;
    if (this.state.loadModal === 'split') {
      displayModal = (
        <SplitTransaction
          onSubmit={this.saveSplitTransaction}
          accountCodes={transactionCodes}
          projects={projects}
          classification={classification}
          transDetails={this.state.transaction}
          initialValues={{
            ...this.state.transaction,
            Coding: this.state.transaction.Coding.length
              ? this.state.transaction.Coding.map((item) => ({
                  ...item,
                  Amount: item.Amount * flip,
                  gstAmount: (item.gstAmount || 0) * flip,
                  percentage: item.percentage * flip,
                }))
              : [{}],
          }}
          onClose={this.cancelSplit}
          toggleRule={this.toggleRule}
          showRule={this.state.showRule}
          contacts={contacts}
          hasGST={hasGST}
          taxTracking={taxTracking}
          setUnallocated={this.setUnallocated}
          unallocated={this.state.unallocated}
          isR1={isR1}
          isRah={isRah}
          isCredit={account.isCreditCard && isRah}
        />
      );
    } else if (this.state.loadModal === 'Rule') {
      displayModal = (
        <TransactionRule
          transaction={this.state.transaction}
          transactionCodes={transactionCodes}
          dateRange={this.props.dateRange}
          closeModal={this.closeModal}
          taxTracking={taxTracking}
          account={this.props.account}
          isRah={this.props.isRah}
        />
      );
    } else if (this.state.loadModal === 'match') {
      displayModal = (
        <MatchTransaction
          account={this.props.account}
          contacts={contacts}
          dateRange={this.props.dateRange}
          onClose={this.cancelSplit}
          transDetails={this.state.transaction}
          uncodeTransaction={this.uncodeTransaction}
          isR1={isR1}
        />
      );
    } else if (this.state.loadModal === 'send') {
      displayModal = (
        <SendTransactions
          selectedTransactions={this.state.selectedTransactionsToSend}
          closeModal={this.closeModal}
        />
      );
    } else if (this.state.loadModal === 'unmatch') {
      displayModal = (
        <UnmatchTransaction
          account={this.props.account}
          contacts={contacts}
          dateRange={this.props.dateRange}
          onClose={this.cancelSplit}
          transDetails={{
            ...this.props.transactionsList.find(
              (item) =>
                item.BankDataGUID === this.state.transaction.BankDataGUID
            ),
          }}
          uncodeTransaction={this.uncodeTransaction}
        />
      );
    } else if (this.state.loadModal === 'Comment') {
      displayModal = (
        <TransactionComment
          closeModal={this.closeModal}
          transactionId={this.state.transaction.BankDataGUID}
        />
      );
    }
    const ConnectedMenu = connectMenu('TransactionContextMenu')(
      TransactionContextMenu
    );

    return (
      <React.Fragment>
          <TransactionListMenu
            codeOpen={this.state.codeOpen}
            toggleCodeOpen={this.toggleCodeOpen}
            sendOpen={this.state.sendOpen}
            toggleSendOpen={this.toggleSendOpen}
            codeTransaction={this.props.codeTransaction}
            bankAccounts={this.props.bankAccounts}
            isR1={isR1}
            isRah={isRah}
            hasGST={hasGST}
            postToRAH={postToRAH}
            handleAcceptRule={this.handleAcceptRule}
            handleSelectAccount={this.handleSelectAccount}
            updateTransactionsList={this.props.updateTransactionsList}
            bookId={bookId}
            account={account}
            dateRange={dateRange}
            timeStamp={timeStamp}
            filterBy={this.props.filterBy}
            transactions={this.state.transactionStats.transactions}
            displayAccount={this.props.displayAccount}
            chart={this.props.transactionCodes.chart}
            transactionCodes={this.props.transactionCodes}
            classification={this.props.classification}
            contacts={contacts}
            matches={matches}
            matchTransaction={this.matchTransaction}
            deselectTransactions={this.deselectTransactions}
            rahSyncing={this.props.rahSyncing}
            rahSyncProgress={this.props.rahSyncProgress}
            retryQueueRAH={retryQueueRAH}
            queueState={queueState}
            taxTracking={taxTracking}
            lastSync={this.props.lastSync}
            codingErrors={codingErrors}
            showModal={this.state.showModal}
          />

        <TransactionDataTable
          codeOpen={this.state.codeOpen}
          sendOpen={this.state.sendOpen}
          showModal={this.state.showModal}
          hasGST={hasGST}
          isRah={isRah}
          isR1={isR1}
          transactionCodes={transactionCodes}
          editableDescription={editableDescription}
          displayAccount={displayAccount}
          classification={classification}
          moveCell={this.state.moveCell}
          setMoveCell={this.setMoveCell}
          isRuleFound={this.isRuleFound}
          leaveRow={this.leaveRow}
          selectTransactions={this.selectTransactions}
          sortColumn={sortColumn}
          sortOrder={sortOrder}
          transactionsList={transactionsList}
          isLoadingTransactions={isLoadingTransactions}
          selectTransaction={this.selectTransaction}
          deselectTransaction={this.deselectTransaction}
          handleSelectAccount={this.handleSelectAccount}
          handleGST={this.handleGST}
          handleContact={this.handleContact}
          handleClassification={this.handleClassification}
          handleDescription={this.handleDescription}
          handleUndoDescription={this.handleUndoDescription}
          handleQuantity={this.handleQuantity}
          handleAcceptRule={this.handleAcceptRule}
          showSplitModalHandler={this.showSplitModalHandler}
          showRuleModalHandler={this.showRuleModalHandler}
          showCommentModalHandler={this.showCommentModalHandler}
          hideColumns={hideColumns}
          matches={matches}
          taxTracking={taxTracking}
          selectCell={this.props.selectCell}
          account={account}
          contacts={contacts}
          focusedCellChange={this.focusedCellChange}
          matchLoadingList={matchLoadingList}
          searchText={this.props.searchText}
          filterBy={this.props.filterBy}
          uncodedOnly={this.props.uncodedOnly}
          focusedCell={this.state.focusedCell}
          updateTransactionsStat={this.updateTransactionsStat}
          copyCoding={this.copyCoding}
          apiError={apiError}
          getTransactions={getTransactions}
          dateRange={dateRange}
          bookId={bookId}
          sortRows={this.props.sortRows}
          handleSorting={this.props.handleSorting}
          activateCell={this.activateCell}
          version={version}
          rowsVersion={this.state.rowsVersion}
          removeMatchList={this.props.removeMatchList}
          removeMatchButton={removeMatchButton}
          codingErrors={codingErrors}
        />

        <TransactionStats
          transactionStats={this.state.transactionStats}
          filename={filename}
          isSaving={isSaving}
        />

        <Dialog
          open={showRemoveModal}
          onClose={this.closeRemoveModal}
          maxWidth={false}
          fullWidth={false}
        >
          <RemoveTransactionTable
            transactions={transactionsList}
            handleClicked={(value) => this.removeCheckboxClicked(value)}
            selected={this.state.removeSelected}
            closeRemoveModal={this.closeRemoveModal}
            handleRemoveClicked={this.removeSelectedTransactions}
            selectAllCheckboxClicked={this.selectAllCheckboxClicked}
          />
        </Dialog>
        <Dialog
          open={this.state.showSendModal}
          onClock={this.closeSendModal}
          maxWidth={false}
          fullWidth={false}
          >
            Modal
          </Dialog>
        <Dialog
          open={this.state.showModal}
          onClose={this.closeModal}
          maxWidth={false}
          fullWidth={false}
        >
          {displayModal}
        </Dialog>
        <ConnectedMenu
          showRuleModal={this.showRuleModalHandler}
          showCommentModal={this.showCommentModalHandler}
          onToggleTransaction={this.handleToggleLockTransaction}
          isR1={isR1}
          isRah={isRah}
          isRuleFound={this.isRuleFound}
        />
      </React.Fragment>
    );
  }
}

TransactionListPage.propType = {
  bankAccounts: PropTypes.array.isRequired,
  transactions: PropTypes.array.isRequired,
  transactionCodes: PropTypes.object.isRequired,
  projects: PropTypes.array.isRequired,
  contacts: PropTypes.array.isRequired,
  dateRange: PropTypes.string.isRequired,
  classification: PropTypes.string.isRequired,
  apiError: PropTypes.bool.isRequired,
  timeStamp: PropTypes.number.isRequired,
  matches: PropTypes.array.isRequired,
  removeMatchList: PropTypes.array.isRequired,
  isLoadingTransactions: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    bankAccounts: state.transactions.bankAccounts,
    transactionsList: _.filter(state.transactions.transactionsList, 'display'),
    isLoadingTransactions: state.transactions.isLoadingTransactions,
    transactionCodes: state.transactions.transactionCodes,
    projects: state.transactions.projects,
    contacts: state.transactions.contacts,
    classification: state.transactions.classification,
    apiError: state.transactions.apiError,
    timeStamp: state.transactions.timeStamp,
    matches: state.transactions.matches,
    filename: state.transactions.filename,
    removeMatchList: state.transactions.removeMatchList,
    filterBy: state.transactions.filterBy,
    codingErrors: state.transactions.codingErrors,
    matchLoadingList: state.transactions.matchLoadingList
  };
}

export default connect(mapStateToProps, actions)(TransactionListPage);


// WEBPACK FOOTER //
// ./src/components/TransactionList/TransactionListPage.js